<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span @click="GoreportOutside">武装自己></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>荣奋刚 “权力意味着责任和担当”</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>荣奋刚，全国纪检监察系统先进工作者、山西省监委委员。</h3>


        <h3>40天查结忻州市委原书记董洪运严重违纪案，27天查结省国土资源厅原厅长李建功严重违纪案，20天查结省煤炭厅原厅长吴永平严重违纪案……山西省监委委员荣奋刚用实际行动诠释了责任和担当。</h3>
        <h3>　2014年中央严肃查处山西系列腐败案件，当时山西省内政治生态严重恶化，腐败案件集中爆发。全省纪检系统查办腐败案件亟需强力打开局面，给群众一个满意的交代。</h3>
        <h3>重压之下用强将，省人民检察院公诉三处处长荣奋刚出任省纪委纪检监察二室主任。上任伊始，荣奋刚接手的一系列案件，牵涉面广、涉案人员多、案情复杂，最多时他一人兼任5个调查组组长。日期倒排、时间切段，他经常是这个调查组分析完案情，又匆忙奔赴下一个调查组分析研判线索，硬骨头一个接一个啃，案件一个接一个突破，“连轴转”“白加黑”成为工作常态。大家都劝他缓一缓，他却说：“组织信任我，把这么重要的任务交给我，我没有理由推脱，必须拿下，以回报组织的信任。”他以上率下，充分发扬能打硬仗、敢打硬仗、善打硬仗的优良作风，团结带领调查组的同志们北上南下、东奔西跑，连续查处省国土资源厅原厅长、省煤炭厅原厅长、忻州市委原书记、高平系列腐败案等影响恶劣的重要案件，在社会上引起强烈反响。</h3>
        <h3>从资深检察官到纪检干部，不单单是身份的变化，更多意味着思维观念和工作方式的转变。荣奋刚在思想认识、责任担当、方法措施上紧跟中央纪委、省委和省纪委部署要求，以坚强党性和责任担当把握运用好监督执纪“四种形态”，既能办大案要案、打恶仗硬仗，又善于抓早抓小、动辄则咎。
　　
</h3>
        <h3>2016年上半年，荣奋刚负责的纪检监察二室共对17名省管干部进行了谈话，通过耐心细致的思想政治工作，有15名谈话对象主动承认在党的十八大前不同程度地存在收受礼金礼品，为身边工作人员谋利等倾向性、苗头性问题，2名谈话对象确实存在一定违纪问题，对这些问题都及时给予组织处理、提醒谈话和诫勉，拉起了纪律的警戒线。</h3>
        <h3>从事纪律审查工作，不仅需要较高的政治觉悟和业务素养，更需要注重自身品行修养。在上级领导和同事们心中，荣奋刚是省纪委的纪律审查标杆，但在他自己心中，却始终认为荣誉是组织认可，成绩是大家共同努力的结果。在工作中，他德高为师，带队伍言传身教，经常身先士卒冲在第一线，毫无保留地传授自己多年积累的经验。对待权力，他始终如履薄冰、兢兢业业，把他信奉的“权力意味着责任和担当”体现在工作中。他工作生活中带头落实中央八项规定精神，坚持高标准、严守纪律红线，在荣奋刚的带领下，山西省纪委纪检监察二室成为一支作风优良、敢打硬仗、能打胜仗的战斗队。</h3>
        <h3>荣誉在身而不自恃，奋勇向前永不退却，刚正不阿嫉恶如仇。荣奋刚正是这样一位时刻自省、自警、自强的纪检监察干部，做尊崇纪律的明白人、严守纪律的带头人、“啄木鸟”式的“护林人”、秉公执纪的“铁面人”是他毕生的追求。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/wzzj1-1.jpg"),
      PicBannertest2: require("../../../../assets/image/wzzj3-1.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    },
    GoreportOutside() {
      this.$router.push({ name: "forumOutside" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img {
  margin: 20px 0;
}
.mg-16{
  margin: 0px 16px;
}
</style>